import { __generator } from "tslib";
import { put, takeEvery, select } from 'redux-saga/effects';
import * as actionTypes from '../constants/actionTypes';
import { showScreen } from '../actionCreators';
import { getCurrentScreen } from '../selectors/screen';
import { getNoOfScreens, getScreenByIndex, getScreenOrder, } from '../selectors/project';
var actions = [
    actionTypes.SHOW_HOME,
    actionTypes.SHOW_NEXT,
    actionTypes.SHOW_PREVIOUS,
];
export default function changeScreen() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions, function (_a) {
                    var currentScreen, currentScreenId, noOfScreens, currentScreenIndex, newIndex, newScreenId;
                    var type = _a.type, transition = _a.transition, meta = _a.meta;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, select(getCurrentScreen)];
                            case 1:
                                currentScreen = _b.sent();
                                currentScreenId = currentScreen.id;
                                if (!currentScreenId) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, select(getNoOfScreens)];
                            case 2:
                                noOfScreens = _b.sent();
                                if (noOfScreens < 2) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, select(function (state) { return getScreenOrder(state, currentScreenId); })];
                            case 3:
                                currentScreenIndex = (_b.sent()) - 1;
                                newIndex = getNextScreenIndex(type, currentScreenIndex, noOfScreens);
                                return [4 /*yield*/, select(function (state) {
                                        return getScreenByIndex(state, newIndex);
                                    })];
                            case 4:
                                newScreenId = (_b.sent()).id;
                                if (!(currentScreenId !== newScreenId)) return [3 /*break*/, 6];
                                return [4 /*yield*/, put(showScreen(newScreenId, transition, undefined, meta))];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getNextScreenIndex(actionType, currentIndex, noOfScreens) {
    switch (actionType) {
        case actionTypes.SHOW_HOME:
            return 0;
        case actionTypes.SHOW_NEXT:
            return (currentIndex + 1) % noOfScreens;
        case actionTypes.SHOW_PREVIOUS:
            return (currentIndex - 1 + noOfScreens) % noOfScreens;
        default:
            throw new Error("Invalid action type: " + actionType);
    }
}
